// Module
var code = `<template class="portfolio-selector">
  <require from="./portfolio-selector.scss"></require>
  <mdc-select label.bind="label" value.bind="value" hoist-to-body>
    <mdc-list>
      <mdc-list-item value="">All portfolios</mdc-list-item>
      <mdc-list-item repeat.for="p of portfolios" value.bind="p.name">\${p.name}</mdc-list-item>
    </mdc-list>
  </mdc-select>
</template>
`;
// Exports
export default code;